// For product item card / ATC pop up notice
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-product-popup-button]").forEach(button => {
    button.addEventListener("click", function () {
      const id = this.dataset.product;
      const popup = document.getElementById(`product-popup-${id}`);
      if (popup) {
        popup.classList.remove("hidden");
        document.body.style.overflow = "hidden";
      }
    });
  });
  document.querySelectorAll(".product-popup-hide").forEach(button => {
    button.addEventListener("click", function () {
      const id = this.dataset.product;
      const popup = document.getElementById(`product-popup-${id}`);
      popup.classList.add("hidden");
      document.body.style.overflow = "";
    });
  });
});
